import { styled as t } from "./styled2.mjs";
const l = t("ul")`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ theme: i }) => i.spacing(1)};
`;
export {
  l as FileListContainer
};
//# sourceMappingURL=styles41.mjs.map
